import { useEffect, useRef } from "react";

import { useRemoteConfigContext } from "@shapr3d/frontend-lib";
import { useLocation } from "react-router-dom";

import useTracker from "../../../utils/useTracker";

export const TrackPageView = () => {
  const location = useLocation();
  const tracker = useTracker();

  useEffect(() => {
    tracker.trackURLChanged();
  }, [location, tracker]);

  const { initialLoadFinished, isLoading } = useRemoteConfigContext();

  const previouslyTrackedPathname = useRef("");
  useEffect(() => {
    if (
      previouslyTrackedPathname.current != location.pathname &&
      initialLoadFinished &&
      !isLoading
    ) {
      previouslyTrackedPathname.current = location.pathname;
      tracker.trackPageView();
    }
  }, [location, initialLoadFinished, isLoading, tracker]);

  return null;
};
